import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from 'antd';
import PropTypes from 'prop-types';
import {ReactComponent as BankingSvgImage} from '../../../../static/images/pages/subscriptions/empty-banking.svg';
import {ReactComponent as EmptyCardSvgImage} from '../../../../static/images/pages/cards/empty-cards.svg';
import Empty from '../../../Empty';

const variants = {
  BANKING: 'banking',
  EMPTY: 'empty'
}

const {BANKING, EMPTY} = variants;

const EmptyCards = ({
  description,
  enableButton = false,
  onClick,
  variant = EMPTY,
  ...rest
}) => {
  const [t] = useTranslation(['subscriptions', 'cards']);

  const getProps = (variant) => {
    const tPrefix = {
      [BANKING]: 'subscriptions',
      [EMPTY]: 'cards'
    }
    const prefix = tPrefix[variant] || '';
    return {
      buttonText: t(`${prefix}:empty.variants.${variant}.buttonText`),
      description: t(`${prefix}:empty.variants.${variant}.description`),
      title: t(`${prefix}:empty.variants.${variant}.title`)
    };
  }

  const getImage = (variant) => {
    const images = {
      [BANKING]: <BankingSvgImage />,
      [EMPTY]: <EmptyCardSvgImage />
    };
    return images[variant] || undefined;
  }

  const {
    buttonText,
    description: variantDescription,
    image,
    title
  } = useMemo(() => ({
    ...getProps(variant),
    image: getImage(variant)
  }), [variant]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Empty
      description={description || variantDescription}
      image={image}
      title={title}
      {...rest}
    >
      {enableButton && (
        <Button
          onClick={onClick}
          size='large'
          type='primary'
        >
          {buttonText}
        </Button>
      )}
    </Empty>
  );
}

EmptyCards.propTypes = {
  description: PropTypes.any,
  enableButton: PropTypes.bool,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf([BANKING, EMPTY])
}

export default EmptyCards;
